module.exports = __webpack_public_path__ + "kudos_45.svg?a70cd60aa75655203dbb81b85f2f6df3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_45.svg
// module id = 145
// module chunks = 0